import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiService} from "../../api.service";
import {AuthService} from "../../../services/auth.service";
import {IPushJobStatus, PushJobKind, PushJobRequest} from "./dto/push-job";

/**
 * Both kinds expose the same job lifecycle, only under a different route prefix: exercise pushes
 * live under the admin controller, workout pushes under the workouts controller.
 */
@Injectable({providedIn: "root"})
export class PushJobsControllerService {
  constructor(private apiService: ApiService) {}

  private base(kind: PushJobKind): string {
    return kind === "Workout" ? "/workouts/push-jobs" : "/admin/exercise-push-jobs";
  }

  create(kind: PushJobKind, payload: PushJobRequest): Observable<IPushJobStatus> {
    return this.apiService.post<IPushJobStatus>(
      this.base(kind),
      payload,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  getCurrent(kind: PushJobKind): Observable<IPushJobStatus | null> {
    return this.apiService.get<IPushJobStatus | null>(
      `${this.base(kind)}/current`,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  get(kind: PushJobKind, jobId: string): Observable<IPushJobStatus> {
    return this.apiService.get<IPushJobStatus>(
      `${this.base(kind)}/${jobId}`,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  downloadLog(kind: PushJobKind, jobId: string): Observable<Blob> {
    return this.apiService.getBlob(
      `${this.base(kind)}/${jobId}/log`,
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  cancel(kind: PushJobKind, jobId: string): Observable<IPushJobStatus> {
    return this.apiService.post<IPushJobStatus>(
      `${this.base(kind)}/${jobId}/cancel`,
      {},
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  retry(kind: PushJobKind, jobId: string): Observable<IPushJobStatus> {
    return this.apiService.post<IPushJobStatus>(
      `${this.base(kind)}/${jobId}/retry`,
      {},
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }

  acknowledge(kind: PushJobKind, jobId: string): Observable<void> {
    return this.apiService.post<void>(
      `${this.base(kind)}/${jobId}/acknowledge`,
      {},
      {},
      AuthService.defaultTokenHeader().headers,
    );
  }
}
